import {Theme} from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import {WithStyles} from '@material-ui/core/styles/withStyles';

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      minHeight: '100%',
      flexDirection: 'column',
    },
  });

export type Styles = WithStyles<typeof styles>;
